/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIArticleFileSearchResult
 */
export interface APIArticleFileSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIArticleFileSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIArticleFileSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticleFileSearchResult
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleFileSearchResult
     */
    fileName?: string;
    /**
     * 
     * @type {number}
     * @memberof APIArticleFileSearchResult
     */
    fileSize?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIArticleFileSearchResult
     */
    storedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIArticleFileSearchResult
     */
    lastModifiedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIArticleFileSearchResult
     */
    articleId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticleFileSearchResult
     */
    articleName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleFileSearchResult
     */
    articleNumber?: string;
}

/**
 * Check if a given object implements the APIArticleFileSearchResult interface.
 */
export function instanceOfAPIArticleFileSearchResult(value: object): value is APIArticleFileSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function APIArticleFileSearchResultFromJSON(json: any): APIArticleFileSearchResult {
    return APIArticleFileSearchResultFromJSONTyped(json, false);
}

export function APIArticleFileSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIArticleFileSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'key': json['key'] == null ? undefined : json['key'],
        'fileName': json['file_name'] == null ? undefined : json['file_name'],
        'fileSize': json['file_size'] == null ? undefined : json['file_size'],
        'storedAt': json['stored_at'] == null ? undefined : (new Date(json['stored_at'])),
        'lastModifiedAt': json['last_modified_at'] == null ? undefined : (new Date(json['last_modified_at'])),
        'articleId': json['article_id'] == null ? undefined : json['article_id'],
        'articleName': json['article_name'] == null ? undefined : json['article_name'],
        'articleNumber': json['article_number'] == null ? undefined : json['article_number'],
    };
}

export function APIArticleFileSearchResultToJSON(value?: APIArticleFileSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'key': value['key'],
        'file_name': value['fileName'],
        'file_size': value['fileSize'],
        'stored_at': value['storedAt'] == null ? undefined : ((value['storedAt'] as any).toISOString()),
        'last_modified_at': value['lastModifiedAt'] == null ? undefined : ((value['lastModifiedAt'] as any).toISOString()),
        'article_id': value['articleId'],
        'article_name': value['articleName'],
        'article_number': value['articleNumber'],
    };
}

